import { render, staticRenderFns } from "./MoreOrdersList.vue?vue&type=template&id=df7fa3a2&scoped=true&"
import script from "./MoreOrdersList.vue?vue&type=script&lang=js&"
export * from "./MoreOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./MoreOrdersList.vue?vue&type=style&index=0&id=df7fa3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7fa3a2",
  null
  
)

export default component.exports